export type AttachmentTemplate = {
  label: string;
  href?: string;
};

const ATTACHMENT_TEMPLATES: Record<string, AttachmentTemplate> = {
  master_rate_card_attachment: { label: "Download sample template (.csv)" },
};

export function resolveAttachmentTemplate(
  fieldName: string,
): AttachmentTemplate | undefined {
  return ATTACHMENT_TEMPLATES[fieldName];
}
